import Spinner from "@cloudscape-design/components/spinner";
import SpaceBetween from "@cloudscape-design/components/space-between";
import Box from "@cloudscape-design/components/box";
import { useEffect, useRef, useState } from "react";
import { api, errorMessage, writeToken } from "../../api/client";
import type { LoginResponse } from "../../api/types";
import { readGoogleCallback } from "../../lib/google-sign-in";
import { navigate } from "../../router/useRoute";
import { PublicShell } from "./PublicShell";
import { ResultPage } from "./ResultPage";

/**
 * `/auth/google`: Google trả `id_token` về đây trong phần `#…` của địa chỉ.
 *
 * Đổi token lấy phiên FaceGo rồi vào thẳng trang thành viên. Người dùng tự đóng
 * cửa sổ chọn tài khoản thì quay về trang đăng nhập, không báo lỗi.
 */
export function GoogleCallbackPage() {
  const [error, setError] = useState("");
  const started = useRef(false);

  useEffect(() => {
    // StrictMode chạy effect hai lần; lượt chờ chỉ đọc được một lần nên phải chặn lượt thứ hai.
    if (started.current) return;
    started.current = true;
    const result = readGoogleCallback();
    // Bỏ token khỏi thanh địa chỉ ngay, đừng để nó nằm trong lịch sử trình duyệt.
    history.replaceState({}, "", "/auth/google");
    if (result.kind === "cancelled") {
      navigate("/login", { replace: true });
      return;
    }
    if (result.kind === "error") {
      setError(result.message);
      return;
    }
    void api<LoginResponse>("/extension/auth/google", {
      method: "POST",
      body: {
        channel: "web",
        id_token: result.idToken,
        installation_key: null,
        nonce: result.pending.nonce,
        referral_code: result.pending.referralCode,
        remember: result.pending.remember,
      },
    })
      .then((response) => {
        writeToken(response.token);
        navigate("/member", { replace: true });
      })
      .catch((reason: unknown) => setError(errorMessage(reason)));
  }, []);

  if (error) {
    return <ResultPage title="Chưa đăng nhập được bằng Google" detail={error} status="error" actionLabel="Về trang đăng nhập" actionHref="/login" />;
  }
  return (
    <PublicShell title="Đăng nhập bằng Google">
      <SpaceBetween direction="horizontal" size="xs" alignItems="center">
        <Spinner />
        <Box variant="span">Đang đăng nhập…</Box>
      </SpaceBetween>
    </PublicShell>
  );
}
